module.exports = __webpack_public_path__ + "img/syukyaku-EC-mo-003.cbaad00b.jpg";